import _ from 'lodash'

var angularGridValueGetters = {
  intValueGetter: intValueGetter,
  byPath: byPath
}

function intValueGetter(field:any) {
  return 'data["' + field + '"].toString()'
}

function byPath(path:any) {
  return (params:any) => {
    return _.get(params.data, path)
  }
}

export default angularGridValueGetters